import { getAsync as _getAsync, patchAsync as _patchAsync } from "../api";

const BASE_URL = "/conversations/notifications";

export async function getAllUnreadByIdentityToNotify(identityToNotify) {
    return _getAsync({ url: BASE_URL, data: { identityToNotify } });
}

export async function markNotificationsAsRead(ids) {
    return _patchAsync({ url: BASE_URL, data: { ids } });
}
